/**
 * Prophets — 10 canonical families used by the Lore section.
 *
 * Fully data-driven: adding the official square 1:1 NFT for a family later
 * only requires setting `image: "/img/prophets/<file>.webp"` on the matching
 * entry. The FamilyMediaFrame component swaps automatically from the
 * placeholder to the real image without any layout or code changes.
 *
 * NOTE: These 10 families belong to the Prophets landing page (`/`) and are
 * INDEPENDENT from the /family-race game's families. Do not merge the two.
 */
export const PROPHET_FAMILIES = [
  {
    id: "oracles",
    index: 1,
    name: "The Oracles",
    description: "Visionaries who perceive possible futures through cosmic signals.",
    image: "/img/families/the-oracles.webp",
    nftImage: "/img/prophets/rhea-the-oracles.webp",
    accent: "#338cff",
    alt: "Representative NFT from The Oracles",
  },
  {
    id: "axioms",
    index: 2,
    name: "The Axioms",
    description: "Machine prophets who calculate probabilities and outcomes.",
    image: "/img/families/the-axioms.webp",
    nftImage: "/img/prophets/knox-the-axioms.webp",
    accent: "#ff7a1a",
    alt: "Representative NFT from The Axioms",
  },
  {
    id: "celestials",
    index: 3,
    name: "The Celestials",
    description: "Higher beings connected to universal consciousness.",
    image: "/img/families/the-celestials.webp",
    nftImage: "/img/prophets/raze-the-celestials.webp",
    accent: "#e8edf7",
    alt: "Representative NFT from The Celestials",
  },
  {
    id: "sovereigns",
    index: 4,
    name: "The Sovereigns",
    description: "Elite prophets who control resources and influence outcomes.",
    image: "/img/families/the-sovereigns.webp",
    nftImage: "/img/prophets/vael-the-sovereigns.webp",
    accent: "#e7bd58",
    alt: "Representative NFT from The Sovereigns",
  },
  {
    id: "obsidian",
    index: 5,
    name: "The Obsidian",
    description: "Forbidden prophets who study hidden timelines.",
    image: "/img/families/the-obsidian.webp",
    nftImage: "/img/prophets/voss-the-obsidian.webp",
    accent: "#8b95a3",
    alt: "Representative NFT from The Obsidian",
  },
  {
    id: "ascendants",
    index: 6,
    name: "The Ascendants",
    description: "Psychic prophets who transcended physical limitations.",
    image: "/img/families/the-ascendants.webp",
    nftImage: "/img/prophets/kaela-the-ascendants.webp",
    accent: "#8b5cf6",
    alt: "Representative NFT from The Ascendants",
  },
  {
    id: "harbingers",
    index: 7,
    name: "The Harbingers",
    description: "War prophets who foresee collapse and conflict.",
    image: "/img/families/the-harbingers.webp",
    nftImage: "/img/prophets/zarek-the-harbingers.webp",
    accent: "#ef334f",
    alt: "Representative NFT from The Harbingers",
  },
  {
    id: "helix",
    index: 8,
    name: "The Helix",
    description: "Bio-engineered prophets who evolved beyond humanity.",
    image: "/img/families/the-helix.webp",
    nftImage: "/img/prophets/zayn-the-helix.webp",
    accent: "#36d17c",
    alt: "Representative NFT from The Helix",
  },
  {
    id: "parallax",
    index: 9,
    name: "The Parallax",
    description: "Quantum prophets who perceive multiple realities simultaneously.",
    image: "/img/families/the-parallax.webp",
    nftImage: "/img/prophets/sable-the-parallax.webp",
    accent: "#22d3ee",
    alt: "Representative NFT from The Parallax",
  },
  {
    id: "singularity",
    index: 10,
    name: "The Singularity",
    description: "AI-integrated prophets merged with infinite intelligence.",
    image: "/img/families/the-singularity.webp",
    nftImage: "/img/prophets/sira-the-singularity.webp",
    accent: "#d946ef",
    secondaryAccent: "#22d3ee",
    tertiaryAccent: "#f4e94b",
    alt: "Representative NFT from The Singularity",
  },
];

// The Oracles opens the Family Explorer.
export const INITIAL_FAMILY_ID = "oracles";
